import { render, staticRenderFns } from "./MessagesSystemGroup.vue?vue&type=template&id=78dd728a&scoped=true"
import script from "./MessagesSystemGroup.vue?vue&type=script&lang=js"
export * from "./MessagesSystemGroup.vue?vue&type=script&lang=js"
import style0 from "./MessagesSystemGroup.vue?vue&type=style&index=0&id=78dd728a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dd728a",
  null
  
)

export default component.exports